export default "__VITE_ASSET__0c40c817__"